import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const Wrapper = styled.div`
  color: ${props => (props.withError ? props.theme.colors.error : '#585757')};
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`;

export const Error = styled.div`
  color: ${props => props.theme.colors.error};
  font-size: 12px;
  line-height: 18px;
  position: absolute;
  bottom: -24px;
`;

export const Label = styled.label`
  display: flex;
  width: 100%;
  align-items: center;
  cursor: pointer;
  padding: ${({ extraPadding }) => (extraPadding ? '20px 10px' : 0)};

  span {
    margin-right: 6px;
  }
`;

export const Control = styled.div`
  background-color: #dbdbdb;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  position: relative;
  transition: background-color 0.3s ease-in-out;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -24px;
  left: 15px;

  ${({ isDisabled }) =>
    isDisabled
      ? css`
          opacity: 0.3;
          cursor: default;
        `
      : null};
`;

export const Handle = styled.div`
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05), 0px 2px 1px rgba(0, 0, 0, 0.03),
    0px 1px 1px rgba(0, 0, 0, 0.04);
  transition: left 0.3s ease-in-out;
  border-radius: 7px;
`;

export const Input = styled.input`
  height: ${props => (props.textSize === 'large' ? '48px' : '40px')};
  width: 1px;
  height: 1px;
  position: absolute;
  left: -9999px;

  &:checked {
    & + ${Label} {
      ${Control} {
        background-color: ${props => props.theme.palette.base};

        ${Handle} {
          background-image: url('/images/icons/check.svg');
        }
      }
    }
  }
`;
